import { Form } from "antd";
import { Rule } from "antd/lib/form";
import { BaseModalRef } from "components/BaseModal";
import BaseModalForm from "components/BaseModalForm";
import { MODAL_SIZE_SMALL } from "constants/Layout";
import { find } from "lodash";
import React, { forwardRef, useState } from "react";
import FindingAPI from "restAPI/FindingAPI";
import { FieldTypes } from "utils/formUtils";

type Props = {
  findingId: number;
  afterClose: () => void;
  isV2?: boolean;
  correlations: any[];
};

const AddCorrelatedFindingPopup = forwardRef<BaseModalRef, Props>(
  ({ findingId, afterClose, isV2 = false, correlations = [] }, ref) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const correlateFinding = async () => {
      await form.validateFields();
      setLoading(true);
      try {
        const data = form.getFieldsValue();
        const correlatedFindingIds = data.correlatedFindingIds.trim();
        const response = {
          ...data,
          correlatedFindingIds: correlatedFindingIds.match(/https|#\//g)
            ? correlatedFindingIds.split("/").pop()
            : correlatedFindingIds,
          findingId: findingId.toString(),
        };
        await FindingAPI[isV2 ? "correlateFindingV2" : "correlateFinding"](
          response,
        ).promise;
        afterClose();
      } catch (e) {
        console.error(e);
        throw e;
      } finally {
        setLoading(false);
      }
    };

    const fields = [
      {
        name: "correlatedFindingIds",
        label: "Finding ID/URL",
        required: true,
      },
      {
        name: "correlationName",
        label: "Remediation Group",
        required: true,
        type: FieldTypes.TEXT_AREA,
        rules: [
          {
            validator: (_: Rule, value: string | undefined) => {
              if (value) {
                const foundMatch = find(correlations, {
                  correlationName: value,
                });
                if (foundMatch) {
                  return Promise.reject(
                    `Correlation with name ${value} already exists.`,
                  );
                }
              }
              return Promise.resolve();
            },
          },
        ],
      },
      {
        name: "remediationAction",
        label: "Remediation Action",
        required: true,
        type: FieldTypes.TEXT_AREA,
      },
      {
        name: "note",
        label: "Note",
        required: true,
        type: FieldTypes.TEXT_AREA,
      },
    ];

    return (
      <BaseModalForm
        ref={ref}
        form={form}
        loading={loading}
        title="Add Correlated Findings"
        onOk={correlateFinding}
        fields={fields}
        width={MODAL_SIZE_SMALL}
      />
    );
  },
);

export default AddCorrelatedFindingPopup;
